import { useCallback, useState } from "react";
import {
    useUpdateCompanyModulesRelationMutation,
    useUpdateModuleRelationMutation,
} from "@me-team/host/main/Modules/graphql/modules.hooks";
import { ModuleInputType } from "@me-team/host/main/graphql/types";
import { ApolloQueryResult, useApolloClient } from "@apollo/client";
import { useToast } from "./useToast";
import { useTranslation } from "react-i18next";
import { isRefetchBranches } from "@me-team/host/main/branches/state";

export const useUpdateModulesWithRefetch = <T>(refetchData: () => Promise<ApolloQueryResult<T>>) => {
    const client = useApolloClient();
    const [updateCompanyModuleRelation] = useUpdateModuleRelationMutation();
    const [updateCompanyModulesRelation] = useUpdateCompanyModulesRelationMutation();
    const { showToast, toastText, setShowToast, setToastText } = useToast();
    const { t: translate } = useTranslation();
    const [isDisableMainModules, setIsDisableMainModules] = useState<boolean>(false);

    const updateModules = useCallback(
        async (companyId: number, updates: ModuleInputType[], branchId: number, isNeededToDisable?: boolean) => {
            if (isNeededToDisable) {
                setIsDisableMainModules(true);
            }

            if (updates.length === 1) {
                await updateCompanyModuleRelation({ variables: { companyId, input: updates[0], branchId } });
            } else {
                await updateCompanyModulesRelation({ variables: { companyId, input: updates, branchId } });
            }

            await client.refetchQueries({
                include: ["getCompanyAndRole", "GetCompanyModules"],
            });

            await refetchData();
            isRefetchBranches(true);

            if (isNeededToDisable) {
                setIsDisableMainModules(false);
            }

            setToastText(translate("Saved"));
            setShowToast(true);
        },
        [
            client,
            refetchData,
            setShowToast,
            setToastText,
            translate,
            updateCompanyModuleRelation,
            updateCompanyModulesRelation,
        ]
    );

    return [updateModules, showToast, setShowToast, toastText, isDisableMainModules] as const;
};
